import { useNode } from "@craftjs/core";
import { cn } from "@/lib/utils";
import { applyStyleProps, defaultStyleProps, type ResponsiveStyleProps } from "@/lib/craft/style-props";
import { SpacerBlockSettings } from "@/components/craft/settings/SpacerBlockSettings";

type SpacerBlockProps = {
  height: number;
  style?: ResponsiveStyleProps;
};

export function SpacerBlock({ height = 32, style = defaultStyleProps() }: SpacerBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
    id,
  } = useNode((node) => ({ selected: node.events.selected, id: node.id }));
  const { style: inlineStyle, className: styleClass } = applyStyleProps(style, "desktop", id);

  return (
    <div
      ref={(ref) => { if (ref) connect(drag(ref)); }}
      className={cn(`craft-node-${id}`, styleClass, selected && "bg-primary/5 outline outline-1 outline-dashed outline-primary/30")}
      style={{ ...inlineStyle, height: `${height}px` }}
      aria-hidden
    />
  );
}

SpacerBlock.craft = {
  displayName: "Spacer",
  props: { height: 32, style: defaultStyleProps() },
  rules: { canDrag: () => true },
  related: { settings: SpacerBlockSettings },
};
